module.exports = __webpack_public_path__ + "786020406d31692d2195609e9dca5fdf.gif";